import { useEffect, useRef, useState } from 'react';
import {Link} from 'react-router-dom'
import { LoadingButton } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../../Layout/FooterComponent';



export default function ForgetPassword() {
    const [UserCode, setUserCode] = useState('');
    const inputRefs = useRef([]);
    const Token = "0B0EAA28-ED7A-4EE8-A177-764AE05547CE";

    const handleClear = () => setUserCode('');

    const handleForgetPassword = async (e) => {
        e.preventDefault();
        let data = { UserCode, Token }
        await fetch('/api/UserLogin/ForgetPassword', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                handleClear();
                toast.success(res.message, { position: 'top-center' })
            } else if (res.status === "ERROR") {
                    toast.error(res.message, {
                    position: 'top-center'
                })
                inputRefs.current[res.focus].focus()
            }
        }).catch((err) => {
            toast.error(err, {
                position: 'top-center'
            });
        })
    };
    useEffect(() => {
        inputRefs.current['txtUserCode'].focus();
    }, []);

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            {/*<img src="./assets/img/logo.png" className='img1' alt="..." />*/}
                            <img src="./assets/img/Trackmate-logo.png" className='img1' alt="" />
                        </div>
                        <div className="">
                            <form method='POST' >
                                <h5 className=" fs-4 my-2 text-center" style={{ textShadow: '2px 2px 2px var(--mycolorFilterCheckText)' }}>Forget Password </h5>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">User Code</label>
                                        <input
                                            ref={ref => (inputRefs.current['txtUserCode'] = ref)}
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            name='txtUserCode'
                                            placeholder='User Code'
                                            maxLength='9'
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    console.log(e)
                                                    handleForgetPassword(e)
                                                };

                                            }
                                            }
                                            value={UserCode}
                                            onChange={(e) => {
                                                let { value } = e.target;
                                                setUserCode(value.replace(/[^0-9]/g, ''))
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="py-2 loading">
                                    <LoadingButton style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleForgetPassword} className=' py-1' variant="contained"> Submit </LoadingButton>
                                </div>
                                <Link to={'/login'} className="text-light" style={{ fontSize: "14px" }}>
                                    Back to Login
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme='colored' />
            <Footer/>
        </>
    );
}





